<template>
  <section class="pt-36 pb-24 bg-slate-100">
    <div class="container">
      <div class="text-center max-w-2xl mx-auto">
        <h2 class="md:text-5xl/tight text-3xl font-semibold mb-5">
          <slot></slot>
        </h2>

        <p class="lg:text-lg text-slate-500 leading-7">
          <slot name="description"></slot>
        </p>
      </div>
    </div>
  </section>
</template>
